"use strict";var __createBinding=this&&this.__createBinding||(Object.create?function(e,t,r,i){void 0===i&&(i=r);var a=Object.getOwnPropertyDescriptor(t,r);a&&!("get"in a?!t.__esModule:a.writable||a.configurable)||(a={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,i,a)}:function(e,t,r,i){void 0===i&&(i=r),e[i]=t[r]}),__setModuleDefault=this&&this.__setModuleDefault||(Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t}),__importStar=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)"default"!==r&&Object.prototype.hasOwnProperty.call(e,r)&&__createBinding(t,e,r);return __setModuleDefault(t,e),t},__importDefault=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.VideosGrid=void 0;const react_1=__importStar(require("react")),styled_1=__importDefault(require("../utils/styled")),core_1=require("@blueprintjs/core"),page_1=require("../canvas/page"),VideoGridContainer=(0,styled_1.default)("div")`
  height: 100%;
  overflow: auto;
`,VideoGridCol=(0,styled_1.default)("div")`
  width: 50%;
  float: left;
`,VideoItemWrapper=(0,styled_1.default)("div")`
  padding: 5px;
  width: 100%;
  &:hover .video-grid__item-credit {
    opacity: 1;
  }
`,VideoItemDiv=(0,styled_1.default)("div")`
  position: relative;
`,Video=(0,styled_1.default)("video",react_1.default.forwardRef)`
  width: 100%;
  cursor: pointer;
  display: block;
  max-height: 300px;
  min-height: 50px;
  object-fit: contain;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(16, 22, 26, 0.3);
`,DurationWrapper=(0,styled_1.default)("div")`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 2px 7px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4rem;
`,Duration=(0,styled_1.default)("span")`
  font-size: 12px;
`,Loader=(0,styled_1.default)("div",react_1.default.forwardRef)`
  padding: 3rem;
`,Credit=(0,styled_1.default)("div")`
  position: absolute;
  opacity: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 3px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.6)
  );
  color: white;
  font-size: 10px;
  text-align: center;
`,VideosGrid=({items:e,onSelect:t,loadMore:r,isLoading:i,error:a,getCredit:o})=>{const n=(0,react_1.useRef)(null),d=(0,react_1.useCallback)((e=>{i||(n.current&&n.current.disconnect(),n.current=new IntersectionObserver((e=>{e[0].isIntersecting&&r()})),e&&n.current.observe(e))}),[i]);if(a)return react_1.default.createElement("div",null,a.message);if(!e||0===e.length)return null;const l=e.filter(((e,t)=>t%2==1)),u=e.filter(((e,t)=>t%2==0));return react_1.default.createElement(VideoGridContainer,null,[l,u].map(((e,r)=>react_1.default.createElement(VideoGridCol,{key:r},e.map((e=>react_1.default.createElement(VideoItem,{key:e.id,item:e,onClick:()=>t(e),onDragStart:r=>{(0,page_1.registerNextDomDrop)(((r,i)=>{t(e,r,i)}))},onDragEnd:()=>(0,page_1.registerNextDomDrop)(null),getCredit:o}))),react_1.default.createElement(Loader,{ref:d},i&&react_1.default.createElement(core_1.Spinner,null))))))};exports.VideosGrid=VideosGrid;const VideoItem=({item:e,onClick:t,onDragEnd:r,onDragStart:i,getCredit:a})=>{var o;const n=(0,react_1.useRef)(null),d=(null===(o=e.video_files.find((e=>"sd"===e.quality)))||void 0===o?void 0:o.link)||"";if(!d)return null;const l=new Date(1e3*e.duration).toISOString();let u;return u=e.duration>3600?l.substring(11,19):l.substring(14,19),react_1.default.createElement(VideoItemWrapper,null,react_1.default.createElement(VideoItemDiv,{draggable:!0,onClick:t,onDragEnd:r,onDragStart:i,onMouseEnter:()=>{var e;null===(e=n.current.play())||void 0===e||e.catch((()=>{}))},onMouseLeave:()=>{var e;null===(e=n.current.pause())||void 0===e||e.catch((()=>{})),n.current.currentTime=0}},react_1.default.createElement(Video,{poster:e.video_pictures[0].picture,controls:!1,ref:n,muted:!0,preload:"none"},react_1.default.createElement("source",{src:d})),react_1.default.createElement(DurationWrapper,null,react_1.default.createElement(Duration,null,u)),a&&react_1.default.createElement(Credit,{className:"video-grid__item-credit"},a(e))))};